import { render, staticRenderFns } from "./SourceItem.vue?vue&type=template&id=2c31a354&scoped=true&"
import script from "./SourceItem.vue?vue&type=script&lang=js&"
export * from "./SourceItem.vue?vue&type=script&lang=js&"
import style0 from "./SourceItem.vue?vue&type=style&index=0&id=2c31a354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c31a354",
  null
  
)

export default component.exports